const initBlock = function( $block ) {
	function setupTipsItems() {
		const $items = $block.find( '.tips-item' );
		if ( !$items.length ) {return;}
		$items.each( function() {
			const $item = $( this );
			$item.hover(
				function() {
					const $this = $( this );
					$this.addClass( 'is-hover' );
				},
				function() {
					const $this = $( this );
					$this.removeClass( 'is-hover' );
				}
			);
		} );
	}

	setupTipsItems();
};

app.loadBlock( initBlock, 'section-lawn-care', '.section-lawn-care' );

if ( module.hot ) {
	module.hot.accept();
}
